/**
 * Created by Vadym Yatsyuk on 28.01.18
 */

export * from './ngx-img-fallback.module';
export * from './ngx-img-fallback.directive';